<script setup>
import { computed } from "vue";
import { useGlobalStore } from "@stores/global";
import { useAchievementsStore } from "@stores/achievements";
import { useWorldStore } from "@stores/world";
import IconX from "@components/icons/X.vue";
import Button from "@components/Button.vue";

const globalStore = useGlobalStore();
const achievementsStore = useAchievementsStore();
const worldStore = useWorldStore();

const clip = computed(() => globalStore.modal.payload?.clip ?? null);
const cityName = computed(() => globalStore.modal.payload?.cityName ?? null);

const country = computed(() => {
    if (!cityName.value) return null;
    for (const continent of worldStore.world) {
        for (const c of continent.countries ?? []) {
            if (c.cities?.some((city) => city.name === cityName.value))
                return c;
        }
    }
    return null;
});

const streams = computed(() => country.value?.streams ?? []);

function streamLabel(stream, i) {
    if (stream.name) return stream.name;
    if (streams.value.length === 1) return "Watch the full stream";
    return `Stream ${i + 1}`;
}

function onPlay() {
    if (clip.value?.id == null) return;
    achievementsStore.visit("binge-watcher", clip.value.id);
    if (typeof window.gtag === "function") {
        window.gtag("event", "watched_clip", {
            title: clip.value.title ?? "Unknown",
        });
    }
}
</script>

<template>
    <div
        class="relative isolate flex w-full max-w-197.5 flex-col justify-center max-lg:w-[calc(100vw-16px)]"
    >
        <video
            :key="clip.video"
            controls
            playsinline
            :poster="clip.poster"
            :src="clip.video"
            class="aspect-video w-full"
            @play="onPlay"
        ></video>
        <div class="flex flex-wrap items-center justify-between gap-4 py-4">
            <p class="body-md font-bold uppercase">{{ clip.title }}</p>
            <div v-if="streams.length" class="flex flex-wrap gap-2">
                <Button
                    v-for="(stream, i) in streams"
                    :key="stream.id"
                    :href="stream.url"
                    target="_blank"
                >
                    {{ streamLabel(stream, i) }}
                </Button>
            </div>
        </div>
        <div class="absolute top-4 right-4 size-8 shrink-0">
            <button
                class="text-marine-800 border-marine-600 flex size-full items-center justify-center rounded-sm border-2 bg-yellow-400 shadow-[0_4px_0_0_var(--color-marine-600)]"
                @click="globalStore.closeModal()"
            >
                <span class="sr-only">Close</span>
                <IconX class="size-3.5" />
            </button>
        </div>
    </div>
</template>
